import { defaultOperators, Field } from 'react-querybuilder';
import { Entity } from '../views/CustomProperties/EntityGroups/details/types';

const multiSelectOperators = defaultOperators.filter((op) => op.name === 'in' || op.name === 'notIn');

const checkboxOperators = defaultOperators.filter((op) => op.name === '=' || op.name === '!=');

export const randomFailureFields: (
  domains: Entity[],
  affiliates: Entity[],
  sites: Entity[],
  landingPages: Entity[],
  landingPageGroups: Entity[]
) => Field[] = (domains, affiliates, sites, landingPages, landingPageGroups) => [
  {
    name: 'siteId',
    label: 'Site ID',
    valueEditorType: 'multiselect',
    values:
      sites?.map((site) => ({
        name: site.id.toString(),
        label: `${site.id}: ${site.name}`,
      })) || [],
    operators: multiSelectOperators,
  },
  {
    name: 'domain',
    label: 'Domain',
    inputType: 'string',
    valueEditorType: 'multiselect',
    values:
      domains?.map((domain) => ({
        name: domain.id.toString(),
        label: `${domain.id}: ${domain.name}`,
      })) || [],
    operators: multiSelectOperators,
  },
  {
    name: 'affiliateId',
    label: 'Affiliate ID',
    inputType: 'string',
    valueEditorType: 'multiselect',
    values:
      affiliates?.map((affiliate) => ({
        name: affiliate.id.toString(),
        label: affiliate?.networkAffiliateId
          ? `${affiliate.networkAffiliateId}: ${affiliate.name}`
          : `${affiliate.name}`,
      })) || [],
    operators: multiSelectOperators,
  },
  { name: 'affSub', label: 'Affiliate Sub ID', inputType: 'string' },
  { name: 'affSub2', label: 'Affiliate Sub ID 2', inputType: 'string' },
  {
    name: 'isMobile',
    label: 'Is Mobile',
    valueEditorType: 'checkbox',
    operators: checkboxOperators,
    defaultValue: 'true',
  },
  {
    name: 'landingPageId',
    label: 'Landing Page ID',
    inputType: 'string',
    valueEditorType: 'multiselect',
    values:
      landingPages?.map((landingPage) => ({
        name: landingPage.id.toString(),
        label: `${landingPage.id}: ${landingPage.name}`,
      })) || [],
    operators: multiSelectOperators,
  },
  {
    name: 'landingPageGroupId',
    label: 'Landing Page Group ID',
    inputType: 'string',
    valueEditorType: 'multiselect',
    values:
      landingPageGroups?.map((landingPageGroup) => ({
        name: landingPageGroup.id.toString(),
        label: `${landingPageGroup.id}: ${landingPageGroup.name}`,
      })) || [],
    operators: multiSelectOperators,
  },
];

export const featureCriteriaFields: Field[] = [
  { name: 'user.userId', label: 'User ID', inputType: 'string' },
  { name: 'user.sessionId', label: 'Session ID', inputType: 'string' },
  { name: 'user.siteId', label: 'Site ID', inputType: 'string' },
  { name: 'user.domainId', label: 'Domain ID', inputType: 'string' },
  { name: 'user.sequenceId', label: 'Sequence ID', inputType: 'string' },
  { name: 'user.offerId', label: 'Offer ID', inputType: 'string' },
  { name: 'user.clickId', label: 'Click ID', inputType: 'string' }
];

export const uniqueUserReturnLogicFields: (
  affiliates: Entity[],
  landingPages: Entity[],
  landingPageGroups: Entity[]
) => Field[] = (affiliates, landingPages, landingPageGroups) => [
  { name: 'user.userId', label: 'User ID', inputType: 'string' },
  { name: 'user.sessionId', label: 'Session ID', inputType: 'string' },
  {
    name: 'affiliateId',
    label: 'Affiliate ID',
    inputType: 'string',
    valueEditorType: 'multiselect',
    values:
      affiliates?.map((affiliate) => ({
        name: affiliate.id.toString(),
        label: affiliate?.networkAffiliateId
          ? `${affiliate.networkAffiliateId}: ${affiliate.name}`
          : `${affiliate.name}`,
      })) || [],
    operators: multiSelectOperators,
  },
  {
    name: 'landingPageId',
    label: 'Landing Page ID',
    inputType: 'string',
    valueEditorType: 'multiselect',
    values:
      landingPages?.map((landingPage) => ({
        name: landingPage.id.toString(),
        label: `${landingPage.id}: ${landingPage.name}`,
      })) || [],
    operators: multiSelectOperators,
  },
  {
    name: 'landingPageGroupId',
    label: 'Landing Page Group ID',
    inputType: 'string',
    valueEditorType: 'multiselect',
    values:
      landingPageGroups?.map((landingPageGroup) => ({
        name: landingPageGroup.id.toString(),
        label: `${landingPageGroup.id}: ${landingPageGroup.name}`,
      })) || [],
    operators: multiSelectOperators,
  },
];
